import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import { store } from '@/store';
import { lang, i18n } from '@/boot/i18n';
import sum from 'lodash/sum';
import sortBy from 'lodash/sortBy';
import { makeScreen } from "./_utils";
import { FIB } from '@/config/constants';
var INDICATOR_KIND = FIB.INDICATOR_KIND;

function computeCsat(indicators) {
  // If there's no indicators, there's no CSAT score (which is a weighted average of the indicators). This is a valid value.
  if (!indicators.length) {
    return null;
  } // Determine the total weighted score which *could* be achieved if all scores hit their maximums (= 100% CSAT).


  var weightedMaxScore = sum(indicators.map(function (i) {
    return i.meta.indicator.csatWeight * (i.meta.indicator.trueMax - i.meta.indicator.trueMin);
  }));

  if (!weightedMaxScore) {
    return null;
  } // Work out the total weighted score which *was* achieved.


  var weightedScore = sum(indicators.map(function (i) {
    return (i.value - i.meta.indicator.trueMin) * i.meta.indicator.csatWeight;
  })); // CSAT is total weighted score, as a %.

  return Math.round(weightedScore / weightedMaxScore * 100);
}

var type = 'indicators';
export default {
  type: type,
  requiresTransaction: false,

  /**
   * Determines if an Indicators question should be added to the selection
   *
   * @param {Object} context
   *
   * @returns {Boolean} true if the question should be added to the selection, else false.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", true);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function select() {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders an Indicators Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var survey, section, indicators, renderType;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              survey = context.survey, section = context.section; // Get survey indicators and bail if none available

              indicators = survey.indicators.filter(function (i) {
                return i.kind == INDICATOR_KIND.SURVEY_RATING;
              });

              if (!(!Array.isArray(indicators) || indicators.length < 1)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", null);

            case 4:
              // Sort by descending weight
              indicators = sortBy(indicators, function (b) {
                return -b.weight;
              }); // Configure the rendering type of indicators:

              renderType = 'emoji'; // Create question for each indicator

              return _context2.abrupt("return", makeScreen(context, indicators.map(function (indicator) {
                return {
                  id: section.name + indicator.id,
                  type: "fib-".concat(renderType),
                  required: indicator.isRequired,
                  notApplicable: !indicator.isRequired,
                  label: indicator.name,
                  _meta: {
                    indicator: indicator,
                    renderType: renderType
                  }
                };
              }), {
                title: lang('questions_indicators_title')
              }));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var indicators = context.response // ignore null values - this is where the guest has left a N/A - so we've been told to ignore these
    .filter(function (i) {
      return i.value !== null;
    }) // ensure that the scores we've received are integers, as we're going to be doing some maths
    .map(function (i) {
      return _objectSpread(_objectSpread({}, i), {}, {
        value: parseInt(i.value)
      });
    });
    return {
      indicators: indicators,
      csat: computeCsat(indicators),
      mutateSubmit: function mutateSubmit(submit) {
        // populate the indicators section
        submit.indicators = this.indicators.map(function (i) {
          return {
            id: i.meta.indicator.id,
            score: i.value
          };
        });
        submit.csatScore = this.csat;
      }
    };
  },
  summary: {
    weight: 90,

    /**
     * Build summary content
     * @param {Object} context context
     */
    build: function build(_ref) {
      var builder = _ref.builder;
      var answer = store.getters['answers/firstAnswerOfType'](type);

      if (!answer) {
        return;
      }

      answer.indicators // Put the highest ranking scores at the top
      .sort(function (i, j) {
        return j.value - i.value;
      }).forEach(function (i) {
        // Don't summarise empty ratings
        if (!i.value) {
          return;
        }

        var text = i18n.t('checkout.shareRating', [i.meta.indicator.name]);
        builder[i.meta.renderType](text, i.value);
      });
    }
  }
};